import { ref, set, computed } from '@vue/composition-api';

export default () => {
  const loadingFlags = ref({});

  /**
   * Установка флага лоадера
   * @param {string} flagName - имя стека лоадинга
   * @param {boolean} flag - статус лоадинга
   */
  const setLoadingFlags = ({ flagName, flag }) => {
    set(loadingFlags.value, flagName, loadingFlags.value[flagName] || []);

    if (flag) {
      loadingFlags.value[flagName].push(true);
    } else {
      loadingFlags.value[flagName].pop();
    }
  };

  return {
    loadingFlags: computed(() => loadingFlags.value),
    setLoadingFlags,
  };
};
